module.exports = __webpack_public_path__ + "img/tumour_banner.ee303979.jpeg";